import React from 'react';

import './InfoBar.css';

function InfoBar() {

  return (
    <>
        <div className="infoBar">
          <div className="leftInnerContainer">
            <h3>Chat:</h3>
          </div>
        </div>
    </>

  )
  
};

export default InfoBar;